module.exports = __webpack_public_path__ + "static/desktopcomputer-6a6c86739693f0b15e0cabe2c485b1c2.png";